import type {Outlet} from "#template/runtime-graph/slots"
import type {NodeClassImpl} from "#template/runtime-graph/types"
import {TypeDescriptors} from "#template/runtime-graph/type-descriptors"

const TD = TypeDescriptors

const groupDescriptor = {
    __output_value: TD.outlet(TD.Array(TD.Identity<any>())),
}

export class Group implements NodeClassImpl<typeof groupDescriptor, typeof Group> {
    static descriptor = groupDescriptor
    static uniqueName = "Group"
    __output_value!: Outlet<any>
    $inletKeys?: string[]
    $constKeys?: string[]

    run() {
        const data: any = {}
        if (this.$inletKeys) {
            for (const key of this.$inletKeys) {
                data[key] = (this as any)[key]
            }
        }
        if (this.$constKeys) {
            for (const key of this.$constKeys) {
                data[key] = (this as any)[key]
            }
        }
        this.__output_value.emitIfChanged(data)
    }
}
